import { Directive, HostListener, ElementRef, Optional, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[cdpTrim]',
    standalone: false
})
export class TrimDirective {
    @Input() hasCommaSeperatedTokens = false;
    constructor(
        private el: ElementRef,
        @Optional() private ngControl: NgControl
    ) {}

    @HostListener('blur') onBlur() {
        let trimmedValue = this.el.nativeElement.value.trim();
        if (this.hasCommaSeperatedTokens) {
            trimmedValue = trimmedValue
                .split(',')
                .map((t: string) => t.trim())
                .join(',');
        }
        this.ngControl.control?.setValue(trimmedValue);
    }
}
